import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { environment } from '@environment/environment';
import { ReservaService } from '@infra/reserva/reserva.service';
import { DateUtil } from 'src/app/shared/utils/date.util';

@Component({
  selector: 'app-purchase-summary',
  templateUrl: './purchase-summary.component.html',
  styleUrls: ['./purchase-summary.component.scss'],
})
export class PurchaseSummaryComponent implements OnInit {
  diasReserva: number = 0;
  @Input() showSecondDiv!: boolean;
  @Input() showFirstDiv: boolean = true;
  @Input() totalPrice!: number;
  @Input() totalPriceDiscount!: number;
  @Input() additionalsPrice!: number;
  @Input() additionalsArray!: any;
  @Input() taxasPrice!: number;
  @Input() taxasArray!: any;
  @Input() additionalsArrayLength!: number;
  @Input() enableSticky!: boolean;
  @Input() disableProtectionButton!: boolean;
  @Input() protectionPage = false;
  @Input() taxaServico!: number;
  @Input() valorDiaria: number;
  @Input() diasPeriodo: number;
  @Input() totalDiarias: number;
  @Input() valorHoraExtra: number;
  @Input() valorTotalHorasExtras: number;
  @Input() quantidadeHorasExtras: number;
  @Input() totalDescontoTarifa: number;
  @Output() submitForm: EventEmitter<any> = new EventEmitter();
  @Input() tarifaSelecionada;
  @Input() adicionaisSelecionados;
  firstSelectedDateFormated: string;
  secondSelectedDateFormated: string;
  firstHourSelected: string;
  secondHourSelected: string;
  currentLanguage: string;
  firstHourSelectedLabel: string;
  secondHourSelectedLabel: string;
  customCurrencyDefault: string;
  constructor(public reservaService: ReservaService) {

    this.currentLanguage = localStorage.getItem('language')
    this.customCurrencyDefault = sessionStorage.getItem('customCurrencyDefault')

  }

  ngOnInit(): void {
    this.diffDays();
    this.daysDifference();
    if (this.additionalsArray?.find((additional) => additional.Quantidade > 0)) {
      this.adicionaisSelecionados = true;
    }
  }

  nextPage() {
    this.submitForm.emit();
  }

  daysDifference() {
    if (
      this.reservaService?.homeData?.firstDateSelected &&
      this.reservaService?.homeData?.secondDateSelected
    ) {
      let date1, date2;
      const isEnglish = environment.defaultLanguage === 'en-US';

      const firstDateRaw = this.reservaService.homeData.firstDateSelected;
      const secondDateRaw = this.reservaService.homeData.secondDateSelected;

      if (isEnglish) {
        date1 = new Date(firstDateRaw);
        date2 = new Date(secondDateRaw);
      } else {
        date1 = new Date(DateUtil.changeDDMMtoMMDD(firstDateRaw));
        date2 = new Date(DateUtil.changeDDMMtoMMDD(secondDateRaw));
      }

      const sameDate = firstDateRaw === secondDateRaw;

      const timeDiff = Math.abs(date2.getTime() - date1.getTime());
      let diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
      this.diasReserva = diffDays > 0 ? diffDays : 1;

      const firstHourRaw = this.reservaService?.homeData?.firstHourSelected;
      const secondHourRaw = this.reservaService?.homeData?.secondHourSelected;

      if (firstHourRaw && secondHourRaw) {
        if (isEnglish) {
          this.firstSelectedDateFormated = DateUtil.changeDDMMYYYYtoYYYYYMMDD(firstDateRaw);
          this.secondSelectedDateFormated = DateUtil.changeDDMMYYYYtoYYYYYMMDD(secondDateRaw);
          this.firstHourSelected = convertTo24HourFormat(firstHourRaw);
          this.secondHourSelected = convertTo24HourFormat(secondHourRaw);
          this.firstHourSelectedLabel = this.reservaService.homeData.firstHourSelected;
          this.secondHourSelectedLabel = this.reservaService.homeData.secondHourSelected;
        } else {
          this.firstSelectedDateFormated = firstDateRaw;
          this.secondSelectedDateFormated = secondDateRaw;
          this.firstHourSelected = DateUtil.formatTo24Hour(firstHourRaw);
          this.secondHourSelected = DateUtil.formatTo24Hour(secondHourRaw);
          this.firstHourSelectedLabel = DateUtil.formatTo24Hour(this.reservaService.homeData.firstHourSelected);
          this.secondHourSelectedLabel = DateUtil.formatTo24Hour(this.reservaService.homeData.secondHourSelected);
        }

        if (sameDate) {
          this.diasReserva = 1;
          return;
        }

        const maxDifHour = +sessionStorage.getItem('maximoHoraExtra') || 0;
        const [firstHourStr, firstMinuteStr] = this.firstHourSelected.split(':') || ['0', '0'];
        const [secondHourStr, secondMinuteStr] = this.secondHourSelected.split(':') || ['0', '0'];

        const firstTotalMinutes = (+firstHourStr) * 60 + (+firstMinuteStr);
        const secondTotalMinutes = (+secondHourStr) * 60 + (+secondMinuteStr);

        let diffMinutes = secondTotalMinutes - firstTotalMinutes;
        const cortesiaMinutes = (+sessionStorage.getItem('maximoHoraExtraCortesia') || 0) * 60;
        const maxDifMinutes = maxDifHour * 60;

        if (cortesiaMinutes > 0 && diffMinutes < cortesiaMinutes) {
          diffMinutes = 0;
        }

        if (maxDifHour > 0 && diffMinutes >= maxDifMinutes && this.diasReserva > 0) {
          this.diasReserva += 1;
        }
      }
    }

    // Conversão de hora AM/PM para 24h
    function convertTo24HourFormat(time12h: string): string {
      if (!time12h) return '00:00';
      const [time, modifier] = time12h.trim().split(' ');
      let [hours, minutes] = time.split(':').map(Number);

      if (modifier?.toLowerCase() === 'pm' && hours < 12) {
        hours += 12;
      }
      if (modifier?.toLowerCase() === 'am' && hours === 12) {
        hours = 0;
      }

      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
    }
  }

  diffDays() {
    if (
      this.reservaService?.homeData?.firstDateSelected &&
      this.reservaService?.homeData?.secondDateSelected
    ) {

      if (environment.defaultLanguage === 'en-US') {
        var date1 = new Date(this.reservaService?.homeData?.firstDateSelected);
        var date2 = new Date(this.reservaService?.homeData?.secondDateSelected);
      } else {
        var date1 = new Date(
          DateUtil.changeDDMMtoMMDD(this.reservaService?.homeData?.firstDateSelected)
        );
        var date2 = new Date(
          DateUtil.changeDDMMtoMMDD(this.reservaService?.homeData?.secondDateSelected)
        );
      }
      var timeDiff = Math.abs(date2.getTime() - date1.getTime());
      var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

      if (this.diasReserva == 0) {
        this.diasReserva = 1;
      }

      this.diasReserva = diffDays;

    }
  }

  getProtectionDays(): number {
    const dias = this.diasReserva || 0;
    const flag = this.reservaService?.protectionData?.CobrarDiariaAMaisHoraExtra === 'S';
    const threshold = +(this.reservaService?.protectionData?.QuantidadeHorasInicioCobrancaDiariaHoraExtra || 0);
    const horasExtras = +(this.quantidadeHorasExtras || 0);
    const incremento = flag && threshold > 0 ? Math.floor(horasExtras / threshold) : 0;
    return dias + incremento;
  }

}
